<template>
  <el-form>
    <el-form-item>
      <el-tree
        v-if="visible"
        ref="tree"
        v-loading="loading"
        :data="data"
        :props="defaultProps"
        node-key="id"
        default-expand-all
        show-checkbox
        @check="handleCheckChange"
      />
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="onSubmit">儲存</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { role, syncPermissions ,tree} from '@/api/index'

export default {
  name: 'SyncPermissions',
  props: {
    success: {
      type: Function,
      default: null
    },
    id: {
      type: Number,
      default: 0,
      required: true
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: true,
      data: [],
      defaultProps: {
        children: 'children',
        label: 'title'
      },
      permissionIdList: [],
      halfCheckedKeys: []
    }
  },
  watch: {
    visible() {
      this.role()
    }
  },
  async created() {
    await this.getTree()
    this.role()
  },
  methods: {
    role() {
      if (this.id > 0) {
        this.loading = true
        this.permissionIdList = []

        role({
          id: this.id
        }).then(response => {
          const { data } = response
          this.permissionIdList = data.item.permission_ids
          for (const i of data.item.permission_ids) {
            const node = this.$refs.tree.getNode(i)
            if (node && node.isLeaf) {
              this.$refs.tree.setChecked(node, true)
            }
          }
        }).finally(reason => {
          this.loading = false
        })
      }
    },
    async getTree() {
      const res = await tree({
        'guard_name': 'admin'
      })
      this.data = res.data.tree
    },
    onSubmit() {
      syncPermissions({
        id: this.id,
        permission_ids: this.permissionIdList.concat(this.halfCheckedKeys)
      }).then(response => {
        if (response.code === 200) {
          this.$message({
            message: response.message,
            type: 'success'
          })
          this.success()
        }
      })
    },
    handleCheckChange(data, node) {
      this.permissionIdList = node.checkedKeys
      this.halfCheckedKeys = node.halfCheckedKeys
    }
  }
}
</script>

<style scoped>

</style>
